import { useState } from "react";
import "./JoinBookingModal.css"
import img from "../../../assets/joinBooking.png"
import { toast } from 'react-toastify';
import PageLoader from "../../components/PageLoader/PageLoader";
import axiosInstance from "../../../axiosInstance/axiosInstance";
import { useNavigate } from 'react-router-dom';

export default function JoinBookingModal(props) {
    
    const navigate = useNavigate();
    const [isLoading,setIsLoading] = useState(false);
    const [code, setCode] = useState("");

    const handleSubmit = async() => {
        try{
            if(code.trim()===""){
                toast.error("Please Provide Code");
                return;
            }
            setIsLoading(true);
            console.log("Referral Code:", code);
            const passData = {
                booking_code : code
            }
            const userId = localStorage.getItem("user_id")
            const response = await axiosInstance.post(`/api/v1/users/${userId}/add-to-booking`,passData);

            toast.success("Booking Code Applied Successfully")
            setIsLoading(false);
            props.setIsJoinModal(false);

            // The code was applied to get into this booking, so open it rather than
            // leaving the guest to find it in the list.
            const bookingId = response?.data?.booking_id;
            if(bookingId){
                navigate(`/bookings/${bookingId}`);
            }
        }catch(error){
            console.log(error);
            toast.error(error?.response?.data?.message || "Some Error Occured");
        }
        finally{
            setIsLoading(false);
        }
    };

    const closeModal = ()=>{
        try{
            props.setIsJoinModal(false)
        }catch(error){
            console.log(error)
        }
    }

   
  return (
    <>
        {isLoading && <PageLoader/>}
        <div className="referal-modal-overlay">
            <div className="referal-modal">
                {/* Close Button */}
                <button className="referal-close-btn" onClick = {()=>closeModal()}>
                &times;
                </button>

                {/* Image */}
                <div className="referal-image-container">
                <img
                    src={img}
                    alt="Referral"
                />
                </div>

                {/* Helper text */}
                <div className="referal-modal-info">
                <p>
                    Use your booking code for web check-in or to join a booking.
                    Don't have it? Ask the reception or the person who booked.
                </p>
                </div>

                {/* Form */}
                <div  className="referal-modal-form">
                <input
                    type="text"
                    placeholder="Enter Booking Code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                />
                <button onClick={()=>handleSubmit()}>Submit</button>
                </div>
            </div>
        </div>
    </>
  );
}
